import React, { useState } from "react";
import "./PageLink.css";
// import { RootContext } from "../../RootContextProvider";
import { Switch, message } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { updateLink } from "../../utils/links";
import {
  FaLink,
  FaYoutube,
  FaSpotify,
  FaYoutubeSquare,
  FaSoundcloud,
  FaTwitch,
  FaClock,
} from "react-icons/fa";
import { MdEmail, MdTitle } from "react-icons/md";
import { SiBandcamp, SiDeezer } from "react-icons/si";
import { IoIosImages } from "react-icons/io";

const PageLink = ({
  isAdmin,
  linkDetails,
  currentButtonColor,
  currentFontColor,
  modalEdit,
  setRefresh,
  refresh,
  setDisplayBlockPicker,
  setCurrentLinkType,
}) => {
  const [isActivating, setIsActivating] = useState(false);
  // const { setLinks } = useContext(RootContext);

  const handleLinkActivation = async (checked) => {
    try {
      setIsActivating(true);
      let linkDetailsUpdated = {
        LinkID: linkDetails.LinkID,
        IsActive: checked,
      };
      let res = await updateLink(linkDetails.PageID, linkDetailsUpdated);
      console.log(res);
      setIsActivating(false);
      setRefresh(refresh + 1);
    } catch (e) {
      message.error("Erreur lors de l'activation du lien");
    }
    // Send API CALL TO BACK to update status of link pass linkID and checked
  };

  return (
    <>
      {isAdmin ? (
        <>
          <div className="block-admin">
            <div className="link-settings">
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                checked={linkDetails.IsActive > 0 ? true : false}
                onChange={handleLinkActivation}
                loading={isActivating}
              />
            </div>
            <div
              className="link-details"
              onClick={() => {
                modalEdit(linkDetails);
                setDisplayBlockPicker(false);
                setCurrentLinkType(linkDetails.LinkType);
              }}
            >
              <div
                className="link-display-admin"
                style={{
                  color: currentFontColor,
                  pointerEvents: "none",
                }}
              >
                <div className="link-display-icon">
                  {linkDetails.LinkType === "regular" && (
                    <FaLink className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "youtube-sub" && (
                    <FaYoutubeSquare className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "spotify" && (
                    <FaSpotify className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "soundcloud" && (
                    <FaSoundcloud className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "youtube-video" && (
                    <FaYoutube className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "twitch-channel" && (
                    <FaTwitch className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "email" && (
                    <MdEmail className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "bandcamp-audio" && (
                    <SiBandcamp className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType === "deezer" && (
                    <SiDeezer className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType.startsWith("thumbnail") && (
                    <IoIosImages className="icon-link-admin" />
                  )}
                  {linkDetails.LinkType.startsWith("divider-title") && (
                    <MdTitle className="icon-link-admin" />
                  )}
                </div>
                {linkDetails.IsScheduled ? (
                  <div className="isScheduled">
                    <FaClock />
                  </div>
                ) : (
                  ""
                )}
                <div className="link-display-title">
                  {" "}
                  {linkDetails.LinkTitle.length > 35
                    ? linkDetails.LinkTitle.slice(0, 35) + "..."
                    : linkDetails.LinkTitle}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="regular-link"
            style={{
              backgroundColor: currentButtonColor,
            }}
          >
            <a
              href={linkDetails.LinkUrl}
              style={{
                color: currentFontColor,
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkDetails.LinkTitle}
            </a>
          </div>
        </>
      )}
    </>
  );
};

export default PageLink;
